// import "firebase/compat/firestore";
// import { myFbApp, myFbollection } from "../Utils/fbFunctionInit";

// function AddNewPt(aPt, MRN) {
//   return new Promise((resolve, reject) => {
//     var db = myFbApp.firestore();
//     let theResult = "";
//     db.collection(myFbollection)
//       .doc(`${MRN}`)
//       .set({
//         value: aPt,
//       })
//       .then(function () {
//         // console.log("Value successfully written!");
//         theResult = "Patient successfully added!";
//         resolve(theResult);
//       })
//       .catch(function (error) {
//         console.error("Error writing Value: ", error);
//         theResult = `Error writing Value: ${error}`;
//         reject(theResult);
//       });
//   });
// }

// export default AddNewPt;

import { myFbApp, myFbollection } from "../Utils/fbFunctionInit";

async function AddNewPt(aPt, MRN) {
  const db = myFbApp.firestore();
  const docRef = db.collection(myFbollection).doc(MRN);
  const docSnapshot = await docRef.get();

  if (docSnapshot.exists) {
    const shouldOverwrite = window.confirm(
      "This PT already exists. Do you want to overwrite it?"
    );

    if (shouldOverwrite) {
      try {
        await docRef.set({ value: aPt });
        // console.log("PT data overwritten successfully");
        return "Patient successfully updated!";
      } catch (error) {
        console.error("Error writing Value: ", error);
        return `Error writing Value: ${error}`;
      }
    } else {
      // console.log("PT data not overwritten");
      return "Patient not updated.";
    }
  } else {
    try {
      await docRef.set({ value: aPt });
      // console.log("New PT data saved successfully");
      return "Patient successfully added!";
    } catch (error) {
      console.error("Error writing Value: ", error);
      return `Error writing Value: ${error}`;
    }
  }
}

export async function AddNewRecord(aRecord, uniqueId, theFbCollection, t) {
  const db = myFbApp.firestore();
  const docRef = db.collection(theFbCollection).doc(uniqueId);
  const docSnapshot = await docRef.get();

  if (docSnapshot.exists) {
    const shouldOverwrite = window.confirm(t("RecordExistOverwrite"));

    if (shouldOverwrite) {
      try {
        await docRef.set({ value: aRecord });
        // console.log("PT data overwritten successfully");
        return t("RecordSuccessfullyUpdated");
      } catch (error) {
        console.error("Error writing Value: ", error);
        return `${t("ErrorWritingValue")} ${error}`;
      }
    } else {
      // console.log("PT data not overwritten");
      return t("RecordNotUpdated");
    }
  } else {
    try {
      await docRef.set({ value: aRecord });
      // console.log("New PT data saved successfully");
      return t("RecordSuccessfullyAdded");
    } catch (error) {
      console.error("Error writing Value: ", error);
      return `${t("ErrorWritingValue")} ${error}`;
    }
  }
}
export default AddNewPt;
